import { useState } from 'react';
import { ApolloError } from '@apollo/client';
import { CurrencyCode } from '@99designs/i18n';
import { ContestProductsQuery, useContestProductsQuery } from './ContestProducts.generated';
import { getContestTier } from './utils';
import type { ContestProduct } from './types';

const logoContestTierNames: string[] = [
    'bronze-logo-contest',
    'silver-logo-contest',
    'gold-logo-contest',
    'platinum-logo-contest',
];

export function useLogoPackageConfig() {
    const [logoPackages, setLogoPackages] = useState<ContestProduct[]>([]);
    const [logoPackagesError, setLogoPackagesError] = useState<ApolloError>();

    const { loading } = useContestProductsQuery({
        variables: {
            input: { names: logoContestTierNames },
        },
        onCompleted: (data) => {
            setLogoPackages(populateLogoPackages(data));
        },
        onError: (err) => {
            setLogoPackagesError(err);
        },
    });
    return {
        loading,
        logoPackages,
        logoPackagesError,
    };
}

export function populateLogoPackages(data: ContestProductsQuery): ContestProduct[] {
    return data.products.map((product) => {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        if (!product || product.__typename !== 'ProductContest') return null as any;

        const pricingAmounts = product.pricing.amounts;
        const usdAmount = pricingAmounts.find((amount) => amount.currency === CurrencyCode.USD);

        return {
            id: getContestTier(product.key)?.toUpperCase(),
            name: product.name,
            key: product.key,
            title: product.title,
            description: product.description,
            details: product.details,
            pricing: {
                amountInCents: usdAmount?.amountInCents,
                currency: CurrencyCode.USD,
            },
            tier: getContestTier(product.key),
        } as ContestProduct | undefined;
    });
}
